module.exports = __webpack_public_path__ + "img/contract_logo.693f4ba5.png";